import {
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { DashboardService } from 'src/app/shared/services/dashboard-service/dashboard.service';
import { PortalBuilderService } from 'src/app/shared/services/administratior-service/portal-builder.service';
import { KycService } from 'src/app/shared/services/kyc-services/kyc.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';
import { WalletManagmentService } from 'src/app/shared/services/wallet-service/wallet-managment.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { DocumentUploadPromptComponent, DocumentUploadPromptData } from 'src/app/components/document-upload-prompt/document-upload-prompt.component';

// OpenLayers imports
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { fromLonLat } from 'ol/proj';
import { Style, Circle as CircleStyle, Fill, Stroke, Text } from 'ol/style';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('olMapContainer', { static: false }) olMapContainer!: ElementRef;

  // OpenLayers map
  olMap!: Map;
  vectorSource!: VectorSource;
  vectorLayer!: VectorLayer<VectorSource>;
  selectedProject: any = null;
  popupCoordinate: number[] | null = null;

  pagination: any = {
    limit: 10,
    currentPage: 1,
  };
  paymentType: any;
  userData: any;
  loading: boolean = false;
  
  // Subscription expiry alert (SUB-009)
  showExpiryAlert: boolean = false;
  expiryAlertData: any = null;
  
  // General alerts (ALERT-001 to ALERT-015)
  alerts: any[] = [];
  unreadAlertsCount: number = 0;
  showAlertsPanel: boolean = false;

  summary: any = [];
  success = 10;
  failed = 90;
  in_progress = 50;
  payIn = 0;
  payOut = 0;
  total = 150;

  public dailyTransactionChartData: ChartConfiguration<'line'>['data'] = {
    labels: [],
    datasets: [],
  };
  public dailyTransactionChartDatas: ChartConfiguration<'line'>['options'] = {
    scales: {
      y: {
        title: {
          display: true,
          text: 'Transaction',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Time in minutes',
        },
      },
    },
  };

  public providerTransactionsChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [],
  };
  public providerTransactionsChartDataLabel: ChartConfiguration<'bar'>['options'] =
    {
      scales: {
        y: {
          title: {
            display: true,
            text: 'Transaction',
          },
        },
        x: {
          title: {
            display: true,
            text: 'Provider',
          },
        },
      },
    };
  public transactionsKpiChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [],
  };
  public partnerTransactionChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [],
  };
  public partnerTransactionChartDataLabel: ChartConfiguration<'bar'>['options'] =
    {
      scales: {
        y: {
          title: {
            display: true,
            text: 'Transaction',
          },
        },
        x: {
          title: {
            display: true,
            text: 'Partner',
          },
        },
      },
    };

  payload = {
    partnerId: '',
    resellerId: '',
    merchantId: '',
    kycStatus: '',
    paymentType: '',
    dateType: 'today | lastWeek',
    startDate: '2023-09-13',
    endDate: '2023-09-13',
  };
  dashboradData: any;
  roleName: any;
  org_id: any;
  projectLocations: any[] = [];
  awardedProjects: any[] = [];
  users: any;
  /** Staff / normal user — dashboard shows only assigned projects, not org-wide stats. */
  isScopedUser = false;

  /** Retries for OpenLayers init until #olMapContainer exists and has layout (guarded by max). */
  private mapInitAttempts = 0;
  private static readonly MAP_INIT_MAX_ATTEMPTS = 40;

  constructor(
    private walletServies: WalletManagmentService,
    private readonly userService: UserService,
    private fb: FormBuilder,
    private portalBuilderServices: PortalBuilderService,
    private DashboardService: DashboardService,
    private readonly apiService: ApiService,
    private toastrMsgService: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.users = JSON.parse(localStorage.getItem('user') || '{}');
    this.roleName = this.users.user.role_name;
    this.org_id = this.users.user.org_id;
    this.users.user.domainCount = this.users.user.domain?.split(',')?.length || 0;
    console.log(this.users.user);

    this.userData = this.userService.getUserDetailsFromSession();
    this.isScopedUser = this.userService.isScopedEndUser();

    // Check for subscription expiry alert (SUB-009)
    this.checkSubscriptionExpiry();

    // Load general alerts (ALERT-001 to ALERT-015)
    this.loadAlerts();

    // Check if staff needs to upload identity documents (for Employee role)
    this.checkDocumentUploadRequired();

    this.fetchData();
    this.fetchProjectLocations();
    // this.fetchAwardedProjects();
  }

  fetchAwardedProjects(): void {
    this.apiService.getProjectsAwardedToMe().subscribe({
      next: (res: any) => {
        if (res.success && res.data) {
          this.awardedProjects = res.data;
        }
      },
      error: () => {}
    });
  }

  viewAwardedProjectWBS(project: any): void {
    this.router.navigate(['/home/work-breakdown-structure', project.project_id], {
      queryParams: { bidderView: 'true' }
    });
  }

  viewAwardedProjectFromAlert(alert: any): void {
    const projectId = alert.metadata?.project_id;
    if (projectId) {
      this.router.navigate(['/home/work-breakdown-structure', projectId], {
        queryParams: { bidderView: 'true' }
      });
      this.toggleAlertsPanel();
    }
  }

  ngAfterViewInit(): void {
    // Map will be initialized after data loads (in fetchData callback)
    // This ensures the map container is in the DOM (it's inside *ngIf)
  }

  ngOnDestroy(): void {
    if (this.olMap) {
      this.olMap.setTarget(undefined);
    }
  }

  initializeOpenLayersMap(): void {
    // Map DOM exists only inside *ngIf="!loading && dashboradData"; skip if dashboard did not load.
    if (!this.dashboradData) {
      return;
    }

    if (!this.olMapContainer || !this.olMapContainer.nativeElement) {
      this.mapInitAttempts++;
      if (this.mapInitAttempts < DashboardComponent.MAP_INIT_MAX_ATTEMPTS) {
        setTimeout(() => this.initializeOpenLayersMap(), 200);
      } else {
        console.warn('Map container not found after retries (dashboard section may be hidden).');
        this.mapInitAttempts = 0;
      }
      return;
    }

    const container = this.olMapContainer.nativeElement;

    // Check if container has dimensions
    const rect = container.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) {
      this.mapInitAttempts++;
      if (this.mapInitAttempts < DashboardComponent.MAP_INIT_MAX_ATTEMPTS) {
        setTimeout(() => this.initializeOpenLayersMap(), 200);
      } else {
        console.warn('Map container has zero dimensions after retries.', rect);
        this.mapInitAttempts = 0;
      }
      return;
    }

    this.mapInitAttempts = 0;

    // Prevent double initialization
    if (this.olMap) {
      return;
    }

    try {
      // Create vector source for markers
      this.vectorSource = new VectorSource();

      // Create vector layer for markers
      this.vectorLayer = new VectorLayer({
        source: this.vectorSource,
        style: (feature) => this.getMarkerStyle(feature),
      });

      // Create the map
      this.olMap = new Map({
        target: container,
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
          this.vectorLayer,
        ],
        view: new View({
          center: fromLonLat([78.9629, 20.5937]), // Center on India
          zoom: 5,
        }),
      });

      // Update map size after initialization to ensure proper rendering
      setTimeout(() => {
        if (this.olMap) {
          this.olMap.updateSize();
        }
      }, 100);

      // Add click handler for markers
      this.olMap.on('click', (event) => {
        const feature = this.olMap.forEachFeatureAtPixel(event.pixel, (f) => f);
        if (feature) {
          const project = feature.get('project');
          if (project) {
            this.showProjectPopup(project, event.coordinate);
          }
        } else {
          // Only close if clicking on empty map area, not on popup
          const target = event.originalEvent.target as HTMLElement;
          if (!target.closest('.project-popup-card')) {
            this.closePopup();
          }
        }
      });

      // Change cursor on hover
      this.olMap.on('pointermove', (event) => {
        const hit = this.olMap.hasFeatureAtPixel(event.pixel);
        this.olMap.getTargetElement().style.cursor = hit ? 'pointer' : '';
      });

      console.log('OpenLayers map initialized successfully', {
        containerSize: { width: rect.width, height: rect.height }
      });

      // Display markers if data is already loaded
      if (this.projectLocations && this.projectLocations.length > 0) {
        this.displayProjectMarkers();
      }
    } catch (error) {
      console.error('Error initializing OpenLayers map:', error);
    }
  }

  getMarkerStyle(feature: any): Style {
    const project = feature.get('project');
    const stage = project?.stage || 'Unknown';
    const color = this.getStageColor(stage);
    const initial = project?.project_name?.charAt(0)?.toUpperCase() || 'P';

    return new Style({
      image: new CircleStyle({
        radius: 14,
        fill: new Fill({ color: color }),
        stroke: new Stroke({ color: '#ffffff', width: 3 }),
      }),
      text: new Text({
        text: initial,
        font: 'bold 12px sans-serif',
        fill: new Fill({ color: '#ffffff' }),
        offsetY: 1,
      }),
    });
  }

  displayProjectMarkers(): void {
    if (!this.vectorSource) {
      console.warn('Vector source not initialized');
      return;
    }

    // Clear existing markers
    this.vectorSource.clear();

    if (!this.projectLocations || this.projectLocations.length === 0) {
      console.log('No project locations to display');
      return;
    }

    console.log('Displaying', this.projectLocations.length, 'project markers');

    const features: Feature<Point>[] = [];

    this.projectLocations.forEach((project) => {
      if (project.coordinates && project.coordinates.lat && project.coordinates.lng) {
        const lat = Number(project.coordinates.lat);
        const lng = Number(project.coordinates.lng);

        if (!isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
          const feature = new Feature({
            geometry: new Point(fromLonLat([lng, lat])),
            project: project,
          });
          features.push(feature);
        }
      }
    });

    // Add all features to the source
    this.vectorSource.addFeatures(features);

    // Fit map to show all markers
    if (features.length > 0) {
      const extent = this.vectorSource.getExtent();
      this.olMap.getView().fit(extent, {
        padding: [50, 50, 50, 50],
        maxZoom: 12,
        duration: 1000,
      });
    }
  }

  showProjectPopup(project: any, coordinate: number[]): void {
    this.selectedProject = project;
    this.popupCoordinate = coordinate;
  }

  closePopup(): void {
    this.selectedProject = null;
    this.popupCoordinate = null;
  }

  viewProjectDetails(project: any): void {
    this.closePopup();
    // Navigate to project details page
    this.router.navigate(['/home/view-project', project.id]);
  }

  centerMapOnProject(project: any): void {
    if (project.coordinates && this.olMap) {
      const lng = Number(project.coordinates.lng);
      const lat = Number(project.coordinates.lat);
      this.olMap.getView().animate({
        center: fromLonLat([lng, lat]),
        zoom: 14,
        duration: 1000,
      });
    }
  }

  getDashboardData(data: any) {
    data = this.payload;
    this.DashboardService.getAdminDashboard(data).subscribe({
      next: (response: any) => {
        console.log(response.data);
        this.success = response.data.summery.success;
        this.failed = response.data.summery.failed;
        this.in_progress = response.data.summery.inProgress;
        this.total = this.success + this.failed + this.in_progress;
        this.payIn = response.data.summery.payIn;
        this.payOut = response.data.summery.payOut;
        this.providerTransactionsChartData = response.data.providerTransactions;
        this.dailyTransactionChartData = response.data.dailyTransactions;
        this.partnerTransactionChartData = response.data.transactions;
      },
      error: (error: any) => {},
      complete: () => {},
    });
  }

  // Doughnut Options
  public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: false,
    cutout: 70,
  };

  doughnutChartDatasets1() {
    let xyz: ChartConfiguration<'doughnut'>['data']['datasets'] = [
      {
        data: [this.success, this.total - this.success],
        backgroundColor: ['#0CAF60', 'silver'],
        label: 'Success',
      },
    ];
    return xyz;
  }

  doughnutChartDatasets2() {
    let xyz: ChartConfiguration<'doughnut'>['data']['datasets'] = [
      {
        data: [this.failed, this.total - this.failed],
        backgroundColor: ['#FF3A6E', 'silver'],
        label: 'Failed',
      },
    ];
    return xyz;
  }

  doughnutChartDatasets3() {
    let xyz: ChartConfiguration<'doughnut'>['data']['datasets'] = [
      {
        data: [this.in_progress, this.total - this.in_progress],
        backgroundColor: ['#C0A145', 'silver'],
        label: 'In-Progress',
      },
    ];
    return xyz;
  }

  doughnutChartDatasets4() {
    let xyz: ChartConfiguration<'doughnut'>['data']['datasets'] = [
      {
        data: [this.total],
        backgroundColor: ['#0058e9', 'silver'],
        label: 'Total Transaction',
      },
    ];
    return xyz;
  }

  fetchData() {
    this.loading = true;
    this.apiService.getDashborad().subscribe({
      next: (res: any) => {
        console.log(res);
        this.dashboradData = res.data;
        this.isScopedUser =
          res.data?.scoped_user === true || this.userService.isScopedEndUser();
        this.loading = false;
        // ViewChild #olMapContainer is inside *ngIf; run CD then init on the next macrotask so the ref exists.
        this.cdr.detectChanges();
        setTimeout(() => {
          this.initializeOpenLayersMap();
        }, 0);
      },
      error: (err: any) => {
        const msg = err?.error?.message || err?.error?.error || err?.message || 'Failed to load dashboard';
        this.toastrMsgService.error(msg);
        this.loading = false;
        // No map init: template hides dashboard content when dashboradData is missing.
      },
      complete: () => {
        console.log('Observable complete');
        this.loading = false;
      },
    });
  }

  refreshData() {
    this.fetchData();
    this.fetchProjectLocations();
  }

  fetchProjectLocations() {
    this.apiService.getProjectLocations().subscribe({
      next: (res: any) => {
        console.log('Project locations:', res);
        this.projectLocations = this.processProjectLocations(res.data || []);

        // Display markers if map is initialized
        if (this.olMap && this.vectorSource) {
          this.displayProjectMarkers();
        }
      },
      error: (err) => {
        console.error('Error fetching project locations:', err);
        this.toastrMsgService.error('Failed to load project locations');
      },
      complete: () => {
        console.log('Project locations fetch complete');
      },
    });
  }

  processProjectLocations(projects: any[]): any[] {
    return projects
      .map((project) => {
        let coordinates = null;

        // Handle location array format
        if (project.location && Array.isArray(project.location) && project.location.length > 0) {
          const locationObj = project.location[0];

          if (
            locationObj &&
            locationObj.lat &&
            locationObj.long &&
            !isNaN(Number(locationObj.lat)) &&
            !isNaN(Number(locationObj.long)) &&
            locationObj.lat !== '' &&
            locationObj.long !== ''
          ) {
            coordinates = {
              lat: Number(locationObj.lat),
              lng: Number(locationObj.long),
            };
          }
        }

        return {
          ...project,
          coordinates: coordinates,
          locationInfo: project.location && project.location.length > 0 ? project.location[0] : null,
        };
      })
      .filter((project) => project.coordinates !== null);
  }

  getStageColor(stage: string): string {
    switch (stage) {
      case 'Pre-Planning':
      case 'Planning':
        return '#3b82f6'; // Blue
      case 'Survey':
      case 'Design Revisions & Scope Adjustments':
        return '#f59e0b'; // Yellow/Orange
      case 'Execution':
        return '#10b981'; // Green
      case 'Closure':
        return '#8b5cf6'; // Purple
      case 'New':
        return '#ef4444'; // Red
      default:
        return '#6b7280'; // Gray
    }
  }

  getDarkerColor(color: string): string {
    const colorMap: { [key: string]: string } = {
      '#3b82f6': '#2563eb', // Blue -> Darker Blue
      '#f59e0b': '#d97706', // Orange -> Darker Orange
      '#10b981': '#059669', // Green -> Darker Green
      '#8b5cf6': '#7c3aed', // Purple -> Darker Purple
      '#ef4444': '#dc2626', // Red -> Darker Red
      '#6b7280': '#4b5563', // Gray -> Darker Gray
    };
    return colorMap[color] || color;
  }

  getStageTextColor(stage: string): string {
    return '#ffffff';
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  formatCurrency(amount: number | string): string {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (!num) return 'N/A';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(num);
  }

  selectProjectFromList(project: any): void {
    this.centerMapOnProject(project);
    this.selectedProject = project;

    // Show popup at project location
    if (project.coordinates && this.olMap) {
      const coordinate = fromLonLat([project.coordinates.lng, project.coordinates.lat]);
      this.popupCoordinate = coordinate;
      
      // Convert map coordinate to pixel position for popup positioning
      setTimeout(() => {
        const pixel = this.olMap.getPixelFromCoordinate(coordinate);
        // Popup will be positioned using CSS based on this coordinate
      }, 100);
    }
  }

  // SUB-009: Check subscription expiry and show alert
  checkSubscriptionExpiry() {
    try {
      const userData = localStorage.getItem('user');
      if (!userData) return;

      const user = JSON.parse(userData);
      
      // Check if subscription exists and has expiry info
      if (user.subscription && user.subscription.statusDetails) {
        const statusDetails = user.subscription.statusDetails;
        const daysRemaining = statusDetails.daysRemaining || 0;

        // Show alert if subscription expires within 7 days
        if (daysRemaining <= 7 && daysRemaining > 0 && statusDetails.isActive) {
          this.showExpiryAlert = true;
          this.expiryAlertData = {
            daysRemaining: daysRemaining,
            status: user.subscription.status || 'Active',
            expiryDate: user.subscription.membership_end_date,
            message: daysRemaining <= 1 
              ? 'Your subscription expires today! Please renew immediately.'
              : daysRemaining <= 3
              ? `Your subscription expires in ${daysRemaining} days. Please renew soon.`
              : `Your subscription will expire in ${daysRemaining} days.`
          };
        } else if (!statusDetails.isActive && daysRemaining === 0) {
          // Subscription already expired
          this.showExpiryAlert = true;
          this.expiryAlertData = {
            daysRemaining: 0,
            status: 'Expired',
            expiryDate: user.subscription.membership_end_date,
            message: 'Your subscription has expired. Please renew to continue using the platform.'
          };
        }
      }
    } catch (error) {
      console.error('Error checking subscription expiry:', error);
    }
  }

  closeExpiryAlert() {
    this.showExpiryAlert = false;
  }

  navigateToRenewal() {
    this.router.navigate(['/home/subscription']);
  }

  // Check if staff needs to upload identity documents
  checkDocumentUploadRequired() {
    // Only check for Employee role (role_id 3)
    if (this.roleName !== 'Employee') {
      return;
    }

    // Check if we should skip the prompt (user selected "don't remind me")
    const skipPrompt = localStorage.getItem('skipDocumentPrompt');
    const skipDate = localStorage.getItem('skipDocumentPromptDate');
    
    if (skipPrompt === 'true' && skipDate) {
      const skipDateObj = new Date(skipDate);
      const now = new Date();
      const daysDiff = Math.floor((now.getTime() - skipDateObj.getTime()) / (1000 * 60 * 60 * 24));
      
      // Skip only for 7 days
      if (daysDiff < 7) {
        return;
      } else {
        // Reset the skip flag after 7 days
        localStorage.removeItem('skipDocumentPrompt');
        localStorage.removeItem('skipDocumentPromptDate');
      }
    }

    // Call API to check document upload requirement
    this.apiService.checkDocumentUploadRequired().subscribe({
      next: (res: any) => {
        if (res.success && res.data) {
          const { isFirstLogin, requiresDocumentUpload, pendingDocuments } = res.data;
          
          // Show dialog if first login or documents are pending
          if (isFirstLogin || requiresDocumentUpload) {
            this.showDocumentUploadPrompt(isFirstLogin, pendingDocuments);
          }
        }
      },
      error: (err) => {
        console.error('Error checking document upload requirement:', err);
      }
    });
  }

  showDocumentUploadPrompt(isFirstLogin: boolean, pendingDocuments: any[]) {
    const dialogData: DocumentUploadPromptData = {
      isFirstLogin,
      pendingDocuments: pendingDocuments || [],
      staffName: this.users?.user?.full_name || ''
    };

    const dialogRef = this.dialog.open(DocumentUploadPromptComponent, {
      width: '480px',
      disableClose: isFirstLogin, // Prevent closing on backdrop click for first login
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'upload') {
        // User chose to upload documents - navigation handled in component
      } else if (result === 'later' || result === 'skip') {
        // User chose to skip/remind later
        console.log('User skipped document upload prompt');
      }
    });
  }

  // Load alerts (ALERT-001 to ALERT-015)
  loadAlerts() {
    this.apiService.getAlerts({ status: 'active', limit: 10 })
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.alerts = res.data;
            this.unreadAlertsCount = res.data.filter((a: any) => a.status === 'active').length;
          }
        },
        error: (err) => {
          console.error('Error loading alerts:', err);
        }
      });
  }

  toggleAlertsPanel() {
    this.showAlertsPanel = !this.showAlertsPanel;
  }

  acknowledgeAlert(alert: any) {
    this.apiService.acknowledgeAlert(alert.alert_id)
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.toastrMsgService.success('Alert acknowledged');
            this.loadAlerts();
          }
        },
        error: (err) => {
          console.error('Error acknowledging alert:', err);
          const errorMsg = err.error?.message || 'Failed to acknowledge alert';
          this.toastrMsgService.error(errorMsg);
        }
      });
  }

  navigateToAlerts() {
    this.router.navigate(['/home/alerts']);
  }

  viewBids(alert: any) {
    const invitationId = alert?.metadata?.invitation_id;
    if (invitationId) {
      this.router.navigate(['/home/boq-bidding/view-bids', invitationId]);
    }
  }

  viewAndSubmitBid(alert: any) {
    const link = alert?.metadata?.bidding_link;
    const token = alert?.metadata?.token;
    if (link) {
      try {
        const url = new URL(link);
        this.router.navigateByUrl(url.pathname || `/bidding/invite/${token || ''}`);
      } catch {
        if (token) this.router.navigate(['/bidding/invite', token]);
      }
    } else if (token) {
      this.router.navigate(['/bidding/invite', token]);
    }
  }
}
